import React from 'react';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/PivotBoard/components/GroupByTable/components/cells/ExpandedTitleColumn/ExpandedTitleColumn.module.scss';

interface Props {
    title: string;
    canExpand: boolean;
    isExpanded: boolean;
    toggleExpandedHandler: () => void;
}

export const ExpandedTitleColumn = ({ title, canExpand, isExpanded, toggleExpandedHandler }: Props) => {
    return (
        <div className={classes.nameGrid}>
            <div className={classes.toggleSlot}>
                {canExpand && (
                    <button className={classes.toggleBtn} onClick={toggleExpandedHandler}>
                        {isExpanded ? (
                            <MuiIcon icon={'keyboard_arrow_down'} fontSize={'2.4rem'} />
                        ) : (
                            <MuiIcon icon={'chevron_right'} fontSize={'2.4rem'} />
                        )}
                    </button>
                )}
            </div>

            <div className={classes.nameText}>{title}</div>
        </div>
    );
};
